import { Injectable } from '@angular/core';
import { CDate, ICalendarDay, IOrder, IReservation, ISite, PriceComponent } from '@curbnturf/entities';
import { dateStringMinusDays } from '@curbnturf/helpers';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as OrderActions from './order.actions';
import { OrderState } from './order.reducer';
import { orderQuery } from './order.selectors';

@Injectable({
  providedIn: 'root',
})
export class OrderFacade {
  initialize = false;

  error$: Observable<string | undefined>;
  priceError$: Observable<string | undefined>;
  order$: Observable<IOrder>;
  prices$: Observable<PriceComponent[]>;
  days$: Observable<ICalendarDay[]>;

  constructor(private store: Store<OrderState>) {
    this.error$ = this.store.pipe(select(orderQuery.getError));
    this.priceError$ = this.store.pipe(select(orderQuery.getPriceError));
    this.order$ = this.store.pipe(select(orderQuery.getOrder));
    this.prices$ = this.store.pipe(select(orderQuery.getPrices));
    this.days$ = this.store.pipe(select(orderQuery.getDays));
  }

  requestPrice(order: IOrder) {
    this.store.dispatch(OrderActions.requestPrice({ reservation: this.toReservation(order) }));
  }

  getDays(siteId?: number, reservationId?: number) {
    if (!siteId) {
      return;
    }

    this.store.dispatch(OrderActions.requestDays({ siteId, reservationId }));
  }

  setDays(dateRange: CDate) {
    this.store.dispatch(OrderActions.setDays({ dateRange }));
  }

  setOrder(order?: IOrder) {
    this.store.dispatch(OrderActions.setOrder({ order }));
  }

  setOrderSite(site: ISite) {
    this.store.dispatch(OrderActions.setOrderSite({ siteId: site?.id }));
  }

  clearPrices() {
    this.store.dispatch(OrderActions.priceFilled({ reservation: { priceComponents: [] } }));
  }

  clearDays() {
    this.store.dispatch(OrderActions.daysFilled({ days: [] }));
  }

  toReservation(order: IOrder): IReservation {
    const reservationDate = new CDate(order.date);

    if (reservationDate.to) {
      reservationDate.to = dateStringMinusDays(reservationDate.to, 1);
    } else if (reservationDate.from) {
      reservationDate.to = reservationDate.from;
    }

    return {
      date: reservationDate,
      site: { id: order.siteId },
      extras: order.extras
        ? order.extras.map((extra) => ({
            count: extra.count,
            extra: { id: extra.id },
          }))
        : undefined,
      rv: { id: order.rvId },
    };
  }

  resetOrder(siteId?: number) {
    this.store.dispatch(
      OrderActions.setOrder({
        order: {
          date: new CDate(),
          extras: [],
          siteId,
        },
      }),
    );
  }
}
